import React, { createContext, ReactNode, useContext, useState } from 'react';
import { ApiResponseType, IClientData, IKalpProductsResponse } from './ContextType';
import axiosInstance from '../api';

type  IKalpProductsContext = {
  kalpClientData: IClientData[];
  kalpProductsApplications: () => Promise<ApiResponseType<IKalpProductsResponse>>;
  isLoading: boolean;
}

const KalpProductsContext = createContext<IKalpProductsContext | undefined>(undefined);

type IKalpProviderProps = {
  children: ReactNode;
}

export const useKalpProductsContext = () => {
  const context = useContext(KalpProductsContext);
  if (!context) {
    throw  new Error('useTheme must be used within a AuthProvider');
  }
  return context;
}

export const KalpProductsProvider: React.FC<IKalpProviderProps> = ({children}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [KalpApplicationData, setKalpApplicationData] = useState<IClientData[]>([]);

  const kalpProductsApplications = async (): Promise<ApiResponseType<IKalpProductsResponse>> => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get('/client-management/clients');
      setKalpApplicationData(response.data.clientsData);
      return {
        success: true,
        message: response.data.message,
        data: response.data
      }
    } catch (e: any) {
      setIsLoading(false);
      return {
        success: false,
        message: e.response.data.message
      }
    } finally {
      setIsLoading(false);
    }
  };

  const contextValue: IKalpProductsContext = {
    kalpClientData: KalpApplicationData,
    kalpProductsApplications,
    isLoading
  };

  return (
    <KalpProductsContext.Provider value={contextValue}>
      {children}
    </KalpProductsContext.Provider>
  )
}
